import { useEffect, useState } from "react";
import { http, rp, nf } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Stat, KatBadge } from "@/components/Ui";
import AiInsight from "@/components/AiInsight";
import ExportButtons from "@/components/ExportButtons";

export default function ReportEta() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const showCost = user.role === "purchasing" || user.role === "keuangan";

  useEffect(() => {
    http.get("/reports/eta").then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, []);

  if (!rows) return <div className="p-8 mono text-sm">Memuat laporan…</div>;
  const totalQty = rows.reduce((a, r) => a + (Number(r.qty) || 0), 0);
  const totalNom = rows.reduce((a, r) => a + (Number(r.total_nominal) || 0), 0);

  return (
    <div data-testid="report-eta-page">
      <PageHeader subtitle="Laporan" title="Laporan ETA Rencana Kedatangan Barang" testId="report-eta-header">
        <ExportButtons kind="eta" testId="export-eta" />
      </PageHeader>
      <div className="p-6 sm:p-8 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Stat testId="report-eta-count" label="Jumlah Shipment" value={nf(rows.length)} />
          <Stat testId="report-eta-qty" label="Total Qty Dalam Perjalanan" value={nf(totalQty)} />
          {showCost && <Stat testId="report-eta-nominal" label="Total Nilai Import" value={rp(totalNom)} accent="#FF3B30" />}
        </div>

        <div className="erp-panel overflow-auto max-h-[70vh]" data-testid="report-eta-table-wrap">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Kode Stock</th><th>Deskripsi</th><th>Type</th><th>Spesifikasi</th>
                <th className="num">Qty</th>
                {showCost && <><th className="num">Harga USD</th><th className="num">Kurs</th><th className="num">Harga IDR</th><th className="num">Total Nominal</th></>}
                <th>Supplier</th><th>No. PO</th><th>Packing List</th><th>Container</th>
                <th>Asal</th><th>Tujuan</th><th>ETA</th><th>Status</th><th>Kategori</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`report-eta-row-${r.kode_stock}`}>
                  <td className="mono font-medium">{r.kode_stock}</td>
                  <td className="max-w-[180px] truncate">{r.deskripsi_produk}</td>
                  <td>{r.type_produk}</td>
                  <td className="max-w-[180px] truncate">{r.spesifikasi_produk}</td>
                  <td className="num">{nf(r.qty)}</td>
                  {showCost && (
                    <>
                      <td className="num">{(Number(r.harga_beli_usd) || 0).toLocaleString("id-ID")}</td>
                      <td className="num">{nf(r.kurs)}</td>
                      <td className="num">{rp(r.harga_beli_idr)}</td>
                      <td className="num font-semibold">{rp(r.total_nominal)}</td>
                    </>
                  )}
                  <td>{r.supplier}</td>
                  <td className="mono">{r.no_po}</td>
                  <td className="mono">{r.no_packing_list}</td>
                  <td>{r.container}</td>
                  <td>{r.pelabuhan_asal}</td>
                  <td>{r.tujuan_pelabuhan}</td>
                  <td className="mono">{r.eta}</td>
                  <td>{r.status_shipment}</td>
                  <td><KatBadge value={r.kategori_pemasaran} /></td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={18} className="text-center text-neutral-500 py-6">Belum ada data ETA</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <AiInsight scope="eta" />
      </div>
    </div>
  );
}
